export const SET_ORDER_NOW_ZIPCODE = "SET_ORDER_NOW_ZIPCODE";

export const setOrderNowZipcode =
  ({ zipCode }) =>
  (dispatch) => {
    dispatch({ type: SET_ORDER_NOW_ZIPCODE, payload: { zipCode } });
  };
